import React, { Component } from 'react'
import styled from 'styled-components'

class WxPrivacyAgreement extends Component {
  state = {
    content: `<b>隐私声明</b>\n
    北京爱和健康科技有限公司深知个人信息对您的重要性，并会尽全力保护您的个人信息安全。在您使用照护同道小程序时，我们恪守以下原则，保护您的个人信息：权责一致、目的明确、选择同意、最少够用、确保安全、主体参与、公开透明。同时，我们承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。\n
    <b>请您在使用我们的产品或服务前，请您仔细阅读本隐私政策的全部条款，以便您了解照护同道使用您个人信息的目的、范围、方式等。一旦您开始使用照护同道产品或服务，即表示您以充分理解并同意本政策。 </b>如果您为儿童，则请您在法定监护人陪同下审阅本隐私政策，经法定监护人审阅并同意后，您方可使用照护同道并向北京爱和健康科技有限公司提供个人信息。如果您或者监护人不同意本隐私政策任何内容，您应立即停止使用照护同道的产品或服务。当您使用照护同道提供的任一服务时，即表示您已同意我们按照本隐私政策来收集、使用、存储和保护您的相关信息。\n
    本隐私权政策旨在协助您了解我们会收集哪些信息、为什么收集这些信息，以及您如何更新、管理、导出和删除自己的信息。若您对本政策有任何问题，请联系：help@ihealthlabs.com.cn。\n
    <b>术语</b>\n
    应用数据缓存：应用数据缓存是指设备上的一种数据存储机制。使用它有很多好处，例如，可让网络应用在未连接互联网的情况下运行，以及可通过提高内容加载速度来改善相关应用的性能。\n
    个人信息：用户向我们提供的、可用于识别用户的个人身份的信息，例如姓名、电话号码等信息，或我们可以正当地通过链接找到此类信息的其他数据。\n
    IP地址：每台连接到互联网的计算机都指定了唯一的编号，称为互联网协议 (IP) 地址。由于这些编号通常都是根据国家/地区的区域指定的，因此 IP 地址通常可用于识别计算机连接至互联网时所在的国家/地区。\n
  
    <b>一、我们如何搜集和使用您的信息？</b>\n
    <b>1. 我们如何搜集您的信息？</b>
    当您使用照护同道的产品或服务提供时，我们可能会向微信申请授权您的头像、昵称、手机号，用于创建账号。\n
    <b>1.1 您提供的信息</b>
    1.1.1 您在注册账户或使用我们的服务时，向我们授权提供微信的相关个人信息，例如您的昵称、电话号码等信息。如果您想充分使用我们提供的各种分享功能，可能还需要创建公开显示的个人资料，其中可能会包含您的姓名和照片。
    1.1.2 您通过我们的服务向微信提供的共享信息，以及您使用我们的服务时上传、提交、存储、发送或接收的信息。\n
    <b>1.2 您在使用服务过程中，我们获取的权限</b>
    我们会收集您使用的服务以及使用方式的信息，如您何时查看了我们的视频和文档。此类信息包括：
    <b>1.2.1 无线网络的使用权限</b>
    您在使用照护同道小程序过程中，我们需要开启您的无线网络权限以便于数据和信息的传输、存储和更新。\n
    <b>2.我们如何使用您的信息</b>
    我们可能将上述收集的信息用作以下用途：
    2.1 注册账户信息，您需要注册一个账户，以便于我们为您提供服务。当您注册时，请您至少提供手机号码，我们将通过发送短信验证码的方式验证您的身份是否有效。
    2.2 在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性；
    2.3 帮助我们设计新服务，改善我们现有服务；
    2.4 执行软件验证、升级服务；
    2.5 让您参与有关我们产品和服务的调查\n
    <b>3.我们承诺</b>
    3.1 我们不会根据敏感类别（例如种族、宗教、性取向或健康状况）向您展示个性化内容；
    3.2 在任何时候、任何情况下都不会向任何第三方出售您的个人信息，我们只会在法律允许的范围内使用根据本协议获得的信息。我们会制定严格的政策保护您的个人信息，除非事先获得您的授权或本声明另有规定之外，不会将您的这些信息对外公开或向第三方提供。
    3.3 当您通过电话与我们联系时，我们可能会保存您的通信和通话的记录和内容，包括您所留下的联系方式等信息，以便与您联系或帮助您解决问题，或记录解决问题的处理方案及结果。为了提供服务及改进服务质量的合理需要，我们还可能使用您的其他相关信息，包括您与医护团队联系时您所提供的相关信息、您参与问卷调查时向我们发送的问卷答复信息。\n
    <b>4.与第三方公司合作</b>
    4.1 我们会要求关联公司及合作单位按照我们的说明、隐私政策以及任何其他适当的保密和安全措施来保证您的个人信息安全。除此之外，我们不会向任何第三方提供或分享您的信息。\n
    <b>5.我们不会将您的个人信息转移或披露给任何非关联的第三方，除非：</b>
    5.1在共享、转让、公开或披露个人信息时，获得您明确同意或您的授权后；
    5.2与国家安全、国防安全直接相关的；
    5.3在法律、法律程序、诉讼或政府部门强制性要求的情况下，我们可能会公开或披露您的个人信息；
    5.4与刑事侦查、起诉、审判和判决执行等直接相关的；
    5.5出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；
    5.6个人信息主体自行向社会公众公开的个人信息；
    5.7在完成合并、分立、收购或资产转让，我们可能会公开或披露您的个人信息；
    5.8与个人信息控制者履行法律法规规定的义务相关的；
    5.9从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；
    5.10以学术研究或公共利益为目的；
    5.11我们认为必要且不违反法律强制性规定的其他情形。\n
    <b>6.隐私声明</b>
    除非经过您的同意，否则我们不会向任何人提供您的敏感个人信息。\n

    <b>二、如何更新、变更、导出、删除您的信息</b>
    1. 您可以要求我们删除或修改信息，例如您想要删除个人帐户，可以发送邮件到help@ihealthlabs.com.cn与我们联络并提出您的要求。
    2. 在有些情况下，我们会出于法律目的或合法业务的需要将数据保留有限的一段时间。我们会尽力确保共同照护的服务能够保护信息免遭意外或恶意删除。因此，如果您删除了某些内容，我们可能会过一段时间才会从我们现用的和备用的系统中删除其副本。
    3. 您可以随时备份个人帐户名下的内容或将其用于非共同照护服务，您可以发邮件到help@ihealthlabs.com.cn与我们联络并提出您的要求。\n

    <b>三、我们如何保护您的个人信息</b>
    所有照护同道产品都内置了强大的安全功能，并且我们制定了严格的信息管理政策，配备专业的技术团队，采取了一系列合理的预防措施，以保护您的个人信息不会遭受未经授权的浏览、披露、滥用、变更、破坏以及损失，其中包括：
    （1）使用加密技术来确保您的数据在传输过程中保持私密性；
    （2）提供多种安全功能来协助您保护自己的帐号安全；
    （3）审查我们在收集、存储和处理信息方面的做法（包括实体安全措施），以防未经授权的人员访问我们的系统；
    （4）所有因提供服务而必须接触个人信息的共同照护 App员工、承包商和代理商等，都需要遵守合同中规定的严格保密义务，否则可将被处分或被解约。
    为了改善共同照护的产品或服务，向您及时通知应用内相关内容的变动，我们会通过APP向您推送必要的内容和相关通知。\n

    <b>四、我们如何处理未成年人提供的个人信息</b>
    我们非常重视未成年人信息的保护。我们只会在法律允许的范围内，或依当地法律取得监护人的同意，或是为了保护未成年人而使用或披露有关未成年人的个人数据。"未成年人"的定义应考虑适用的法律以及各国家和地区的文化惯例。\n

    <b>五、您分享的信息</b>
    1. 我们会提供社交网络服务，您在使用这一类型服务时，您所上传或发布的信息（包括您公开的个人信息、您的通讯录、好友圈）、您对他人上传或发布的信息作出的回应，以及与这些信息有关的日志信息等，只要您不删除这些信息，它们会一直留存在公共领域，并被使用我们服务的其他用户分享、浏览。即使您删除这些信息，有关信息仍可能由其他用户或不受我们控制的非关联第三方独立地缓存、复制或储存，或由其他用户或第三方在公共领域保存。\n

    <b>六、数据传输</b>
    1. 我们使用华为云服务器，因此，我们处理您的信息时需要遵守所在国家或地区的数据保护法律，对您的数据和信息进行传输。
    2. 收到正式的书面投诉后，我们会与投诉方联系。我们会与服务器所在地的监管机构（包括当地的数据保护机构）合作，以解决任何与传输您的数据有关且无法由我们和您直接解决的投诉。\n
    
    <b>七、本政策的更新</b>
    我们可能会不定期修改、更新本隐私政策，有关隐私政策的更新，我们会在共同照护中以通知公告等形式发布，您可以访问共同照护查询最新版本的隐私政策。对于重大变更，我们会向您发出郑重通知（包括对于某些服务，我们会通过短信发送通知，说明对隐私政策进行的更改）。\n

    <b>八、适用范围</b>
    1. 我们的隐私政策适用于由北京爱和健康科技有限公司及其关联公司提供的所有服务，包括共同照护及www.ihealthlabs.com.cn上提供的服务，但是不包括附有独立隐私政策的服务（如第三方提供的产品和服务）。
    2. 我们的隐私权政策不适用于第三方提供的产品和服务，例如在共同照护及www.ihealthlabs.com.cn上由第三方提供的产品和服务，以及在我们的服务中链接到的其他网站，这些产品、服务或网站会有独立的隐私政策予以规范，请另行查阅相应的政策规定。
    3. 对于为我们的服务进行广告宣传，以及可能使用我们的cookie或其他日志信息来投放和使用广告的其他公司和组织，我们的隐私权政策并未涵盖其信息处理政策。
    4. 本隐私政策的签订、生效、履行、争议的解决均适用中华人民共和国法律。
    5. 有关本协议的争议应通过友好协商解决，如果协商不成，该争议将提交公司所在地有管辖权的法院诉讼解决。\n`,
  }
  render() {
    return (
      <RootView>
        <TextContent
          dangerouslySetInnerHTML={{ __html: this.state.content }}
        ></TextContent>
      </RootView>
    )
  }
}

export default WxPrivacyAgreement

const RootView = styled.div`
  background-color: white;
  flex-direction: column;
  width: 100%;
  height: 100%;
`
const TextContent = styled.div`
  padding: 10px;
  white-space: pre-line;
  word-break: break-all;
`



// WEBPACK FOOTER //
// ./src/modules/activity/components/wxPrivacyAgreement.js